import { render, staticRenderFns } from "./CPDueDiligenceMoreInformation.vue?vue&type=template&id=3fe5c54a&scoped=true&"
import script from "./CPDueDiligenceMoreInformation.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceMoreInformation.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceMoreInformation.vue?vue&type=style&index=0&id=3fe5c54a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe5c54a",
  null
  
)

export default component.exports